import { OnInit, Component, ViewEncapsulation, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, ValidationService, DataService, FormatService } from 'app/services';

import { config, messages } from 'app/constants';
import { states } from 'app/constants/states';
import { newCustomer, phoneTypes, contact } from 'app/constants/customer';
import { CreateMyFleetCustomerDialogComponent } from '../create-myfleet-customer-dialog/create-myfleet-customer-dialog.component';

import { debounce, escapeRegExp, find, set, trim } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customer-add',
  templateUrl: './customer-add.component.html',
  styleUrls: ['./customer-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('toggleBox', [
      state(
        'open',
        style({
          height: '480px',
        }),
      ),
      state(
        'closed',
        style({
          height: '0px',
        }),
      ),
      transition('open => closed', [animate('.3s')]),
      transition('closed => open', [animate('0.3s')]),
    ]),
  ],
})
export class CustomerAddComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input('onSubmitData')
  set onSubmitData(data: any) {
    if (data && data.active === 'add-customer') {
      this.onSubmit();
    }
  }
  @Input('customerNameForCreate')
  set customerNameForCreate(data: any) {
    if (data) {
      const nameArray: string[] = data.split(' ');

      this.customer.firstName = nameArray[0] || '';
      this.customer.lastName = nameArray.slice(1).join(' ') || '';

      const fullName = `${this.customer.firstName} ${this.customer.lastName}`;

      this.customer.fullNameQBO = this.helperService.trimString(fullName);
      this.onFirstLastNameChange();
    }
  }
  @Input('customerEmailForCreate')
  set customerEmailForCreate(data: any) {
    if (data) {
      this.customer.emails[0].value = data;
    }
  }
  @Input('customerPhoneForCreate')
  set customerPhoneForCreate(data: any) {
    if (data) {
      this.customer.phones[0].value = data;
    }
  }

  @Input() qboTaxExemptReasons: any[] = [];
  @Input() openFrom: any;
  @Input() setProcessingState: any;
  @Input() setCustomerType: any;
  @Input() isProcessing: boolean;
  @Input() from: string = 'estimate';

  @Output() customerCreated = new EventEmitter();
  @Output() customerCreatedForOther = new EventEmitter();
  @Output() cancelCreatedForOther = new EventEmitter();
  @Output() customerProcessingMode = new EventEmitter();
  @Output() fieldChanged = new EventEmitter();

  @ViewChild('addCustomerForm', { static: true }) addCustomerForm: ElementRef;
  @ViewChild('firstNameElement', { static: true }) firstNameElement: ElementRef;
  @ViewChild('primaryAddress', { static: false }) primaryAddressElement: ElementRef;

  phoneTypes = phoneTypes;
  customer = this.helperService.deepCopy(newCustomer);
  isChargeAccountEnabled: boolean = false;
  customerTypes: any[] = [
    {
      label: 'Regular',
      name: 'Regular',
      value: 'customer',
      icon: 'far fa-user',
      placeholder: 'Customer',
    },
    {
      label: 'Fleet',
      name: 'Fleet',
      value: 'fleet',
      icon: 'far fa-cars',
      placeholder: 'Fleet',
    },
  ];
  errors = {
    emails: {},
    phones: {},
    address: {
      addLine1: '',
      city: '',
      state: '',
      stateCode: '',
      zip: '',
      country: '',
    },
  };
  countryOptions: any[] = [
    { name: 'Canada', value: 'Canada' },
    { name: 'USA', value: 'USA' },
  ];
  tagTypeCustomer: string = this.helperService.deepCopy(config.tags.customer);
  isOpen = false;
  isZipCode1Valid: boolean = true;
  isZipCode2Valid: boolean = true;
  isCreateTagFieldVisible: boolean = false;
  isQboFullNameUniqe: boolean = true;
  nameSuggestions: string[] = [];
  validate: any = {};
  contactOnEmail = false;
  contactOnPhone = false;
  isTagOpen = false;
  tagCreateControl = false;
  tagKey: any;
  tagResults: any;
  customerTags: any[] = [];
  companies: any[] = [];
  tagColor: any = '#919796';
  tagColors: any = config.colors;
  addressStates = states;
  bAddressStates = states;
  addressCityResults: any[] = [];
  bAddressCityResults: any[] = [];
  addressCities: any[] = [];
  bAddressCities: any[] = [];
  allCities: any[] = [];
  config = config;
  isDisplayNameChanged: boolean = false;
  isUnique = debounce(this._isUnique, 800);
  isEmailDisabled: boolean = true;
  isPhoneDisabled: boolean = true;
  companiesSuggestions: any[] = [];
  fleetSettings: any = {};
  isArAccountManagement: boolean = false;
  isGoogleAddressSearchEnabled: boolean = false;
  chargeAccountTogleTooltip = `
  <div class="p-1" style="width: 330px;">
    <div class="font-12 font-secondary-800 text-white">
      Opening a charge account for this customer would mean:
    </div>
    <div class="font-12 font-secondary-800 text-white">
      <p class="mb-0">
        <ul>
          <li>You can maintain an AR balance for them</li>
          <li>You can send bulk statement to them</li>
        </ul>
      </p>
    </div>
  </div>`;
  isMyFleetCenterEnabled = this.dataService.isMyFleetCenterEnabled && this.dataService.isMyFleetCenterConnected;
  companyLocalization: boolean = false;
  isZipCodeLoading = {
    address: false,
    businessAddress: false,
  };
  currentLang: string = 'en';
  companyId: string = '';
  subscription: Subscription;
  customerMandatoryFields: any = this.dataService.customerMandatoryFields;
  fieldsPlaceholder = {
    primaryAddress: {
      addLine1: 'Address 1',
      city: 'City',
      state: 'State/Province',
      zip: 'Zip/Postal code',
      country: 'Country',
    },
    secondaryAddress: {
      addLine1: 'Address 2',
      city: 'City',
      state: 'State/Province',
      zip: 'Zip/Postal code',
      country: 'Country',
    },
  };
  stateResults = {
    address: [],
    businessAddress: [],
  };
  addressResults = {
    address: [],
    businessAddress: [],
  };
  loader = {
    address: { addLine1: false, state: false },
    businessAddress: { addLine1: false, state: false },
  };

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private validationService: ValidationService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private formatService: FormatService,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    this.customer.customerType = this.customerTypes[0];

    this.fetchCustomerTags();
    this.handleDisableContactPref();
    this.isArAccountManagement = this.dataService.isArAccountManagement;
    this.subscription = this.dataService.getCompanyLocalization().subscribe((res: any) => {
      this.companyLocalization = res;

      if (this.subscription) this.subscription.unsubscribe();
    });
    this.getPrefLanguage();
    this.setFeatureFlag();

    this.customer.address.country = this.dataService.locationAddress.country || this.dataService.company?.address?.country;
    this.customer.businessAddress.country = this.dataService.locationAddress.country || this.dataService.company?.address?.country;
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  setFeatureFlag() {
    this.isChargeAccountEnabled = this.dataService.isChargeAccountEnabled;
    this.isArAccountManagement = this.dataService.isArAccountManagement;
    this.isGoogleAddressSearchEnabled = this.dataService.isGoogleAddressSearchEnabled;
    this.customerMandatoryFields = this.dataService.customerMandatoryFields;
    this.fieldsPlaceholder = {
      ...this.fieldsPlaceholder,
      primaryAddress: {
        addLine1: `Address 1 ${this.customerMandatoryFields?.address ? ' *' : ''}`,
        city: `City ${this.customerMandatoryFields?.address ? ' *' : ''}`,
        state: `State/Province ${this.customerMandatoryFields?.address ? ' *' : ''}`,
        zip: `Zip/Postal code ${this.customerMandatoryFields?.address ? ' *' : ''}`,
        country: `Country ${this.customerMandatoryFields?.address ? ' *' : ''}`,
      },
    };
  }

  async getPrefLanguage() {
    if (this.companyLocalization) {
      this.companyId = this.helperService.getCompany().companyId;
      const company = await this.httpService.getCompanyDetails(this.companyId, 'fetchDaylightSavingStatus=true&fetchTimezones=true');
      if (this.dataService.isMultiLocationEnabled) {
        this.currentLang = company.shop.preferredLanguage.toLowerCase();
      } else {
        this.httpService.getCompanyPreferredLanguage().then((res: any) => {
          const lang = res.preferredLanguage;
          if (lang) {
            this.currentLang = lang.toLowerCase();
          }
        });
      }
    }
  }

  handleTagDelete(deletedTag: any) {
    if (this.customerTags && this.customerTags.length) {
      this.customerTags = this.customerTags.filter((tag) => {
        if (deletedTag._id) {
          return tag._id !== deletedTag._id;
        } else {
          return !(tag.name === deletedTag.name && tag.color === deletedTag.color);
        }
      });
    }
  }

  ngAfterViewInit() {
    if (this.from === 'quick-tire-lookup') {
      this.customerProcessingMode.emit(true);
    }
    this.cdr.detectChanges();
  }

  switchLanguage(lang: string) {
    this.currentLang = lang;
  }

  onFieldChange(value: string = '') {
    this.fieldChanged.emit(value);
  }

  fetchCustomerTags() {
    this.httpService.getMultipleTags([config.tags.customer, config.tags.companyName]).then(
      (tags: any[]) => {
        this.customerTags = [];
        this.companies = [];

        tags.forEach((tag: any) => {
          if (tag.type === config.tags.customer) {
            this.customerTags.push(tag);
          } else {
            this.companies.push(tag);
          }
        });

        this.companiesSuggestions = [...this.companies];
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  handleAddAnother(type: string) {
    if (type === 'email' && this.customer.emails.length < 5) {
      const isPrimary = !this.customer.emails.filter(({ isPrimary }) => isPrimary).length;

      this.customer.emails.push({
        ...this.helperService.deepCopy(contact),
        isPrimary: isPrimary,
        contactType: { label: 'Email', value: 'email' },
      });
    } else if (type === 'phone' && this.customer.phones.length < 5) {
      const isPrimary = !this.customer.phones.filter(({ isPrimary }) => isPrimary).length;

      this.customer.phones.push({
        ...this.helperService.deepCopy(contact),
        isPrimary: isPrimary,
        contactType: { label: 'Mobile', value: 'mobile' },
      });
    }
  }

  handleFocus(name: string) {
    set(this.validate, name, '');

    if (name === 'address.state' && !this.stateResults?.address?.length) {
      this.handleStateSearch('', this.customer.address, 'address');
    } else if (name === 'businessAddress.state' && !this.stateResults?.businessAddress?.length) {
      this.handleStateSearch('', this.customer.businessAddress, 'businessAddress');
    }
  }

  handleBlur(name: string) {
    if (name === 'phone' && !this.customer.phone) {
      this.contactOnPhone = false;
    }

    if (name === 'email' && !this.customer.email) {
      this.contactOnEmail = false;
    }
  }

  handleMultiChange(type: string, key: string, index: number, value: any) {
    this.customer[type][index][key] = value;

    if (value && type === 'phones' && key === 'contactType') {
      if (value.value === 'landline') {
        this.customer.phones[index].isPrimary = false;
      }

      if (!this.customer.phones.filter(({ isPrimary }) => isPrimary).length) {
        for (let i = 0; i < this.customer.phones.length; i++) {
          const { isActive, contactType } = this.customer.phones[i];

          if (isActive && contactType && contactType.value === 'mobile') {
            this.customer.phones[i].isPrimary = true;
            break;
          }
        }
      }
    } else if (key === 'isPrimary') {
      this.customer[type].forEach((contact: any, i: number) => {
        if (index !== i) {
          this.customer[type][i].isPrimary = false;
        }
      });
    }

    //Here we are disbale the communication pref according to primary, active, and required value
    if (this.customer.phones.find((phone) => phone.isPrimary && this.helperService.removePhoneFormatting(phone.value).length >= 10 && phone.isActive)) {
      this.isPhoneDisabled = false;
      this.contactOnPhone = true;
    } else {
      this.isPhoneDisabled = true;
    }

    if (this.customer.emails.find((email) => email.isActive && email.isPrimary && this.validationService.validateEmail(email.value))) {
      this.isEmailDisabled = false;
      this.contactOnEmail = true;
    } else {
      this.isEmailDisabled = true;
    }

    //Here we are removing the validation if user type any character
    this.handleEmailAndPhoneValidation(true, { type, index });
  }

  handleMultiFocus(type: string, key: string, index: number, focus: boolean) {
    if (!focus) {
      this.handleDisableContactPref();
      if (key === 'value') {
        if (type === 'emails') {
          this.customer.emails[index].focus = false;
        } else {
          this.customer.phones[index].focus = false;
        }
      }
    } else {
      if (key === 'value') {
        if (type === 'emails') {
          this.customer.emails[index].focus = true;
        } else {
          this.customer.phones[index].focus = true;
        }
      }
    }
  }

  handleDisableContactPref() {
    if (this.customer.emails && this.customer.emails.length) {
      for (let i = 0; i < this.customer.emails.length; i++) {
        const email = this.customer.emails[i];

        if (email.isActive && email.isPrimary && this.validationService.validateEmail(email.value)) {
          this.isEmailDisabled = false;
        }
      }

      if (this.isEmailDisabled) {
        this.contactOnEmail = false;
      }
    }

    if (this.customer.phones && this.customer.phones.length) {
      for (let i = 0; i < this.customer.phones.length; i++) {
        const phone = this.customer.phones[i];

        if (phone.isActive && phone.isPrimary && this.helperService.removePhoneFormatting(phone.value).length >= 10) {
          this.isPhoneDisabled = false;
        }
      }

      if (this.isPhoneDisabled) {
        this.contactOnPhone = false;
      }
    }
  }

  handleChange(type: string, event: any) {
    this.isUnique();
    if (type === 'customerType') {
      this.setCustomerType(event.value);
    }

    /** Check for unique name */
    if (['firstName', 'lastName', 'fullNameQBO'].includes(type)) {
      const fullName = this.helperService.trimString(`${this.customer.firstName || ''} ${this.customer.lastName || ''}`);

      this.customer[type] = event;

      if (this.customer.fullNameQBO === fullName || !this.customer.fullNameQBO) {
        this.customer.fullNameQBO = this.helperService.trimString(`${this.customer.firstName || ''} ${this.customer.lastName || ''}`);
      }

      this.onFirstLastNameChange();
    }

    if (type === 'customerType') {
      if (event.value === 'fleet') {
        if (this.customer.lastName) {
          this.customer.firstName = `${this.customer.firstName} ${this.customer.lastName}`;
        }
      } else {
        this.customer.firstName = this.customer.firstName.replace(new RegExp(`${escapeRegExp(` ${this.customer.lastName}`)}$`), '');
      }
    }

    if (type === 'phone' || type === 'phone2') {
      this.customer[type] = this.helperService.removePhoneFormatting(event);
    } else if (type === 'address-addLine1') {
      this.customer.address.addLine1 = event;
    } else if (type === 'businessAddress-addLine1') {
      this.customer.businessAddress.addLine1 = event;
    } else if (type === 'address-zip') {
      this.isZipCode1Valid = true;
      this.customer.address.zip = event;
    } else if (type === 'businessAddress-zip') {
      this.isZipCode2Valid = true;
      this.customer.businessAddress.zip = event;
    } else if (type === 'taxExempt' || type === 'taxExemptReason') {
      this.validate.taxExemptReason = '';
      this.customer[type] = event;
    } else {
      this.customer[type] = event;
    }
  }

  updateFleetSettings({ fleetSettings }) {
    this.fleetSettings = fleetSettings;
  }

  /** Show tags suggestions in the dropdown */
  onTagFocus() {
    this.scrollToBottom();
  }

  onTagSelect(tag: any) {
    this.customer.tags.push(tag);
  }

  onTagDelete(tags: any[]) {
    this.customer.tags = tags;
  }

  onTagCreate(tag: any) {
    this.customerTags = [...this.customerTags, tag];
  }

  /** Toggle show more  */
  toggle() {
    this.isOpen = !this.isOpen;
  }

  renderCityName(city: string, stateCode: string) {
    if (city && stateCode) {
      return `${city}, ${stateCode}`;
    }

    return '';
  }

  zipChange(event: any, type: string) {
    if (!event) return;
    this.isZipCodeLoading[type] = true;
    this.addressCities = this.allCities;
    this.bAddressCities = this.allCities;

    if (type === 'address') {
      this.customer.address.zip = this.validationService.formatZip(event);
    } else {
      this.customer.businessAddress.zip = this.validationService.formatZip(event);
    }

    const formattedZip = this.helperService.removeSpaceFromString(event).toUpperCase();

    this.httpService
      .getZip(formattedZip)
      .then(
        (res) => {
          if (res) {
            this.customer[type].city = res.city;
            this.customer[type].state = res.state;
            this.customer[type].stateCode = res.stateCode;
            this.customer[type].country = res.country;

            this.validate[type].city = '';
            this.validate[type].state = '';
            this.validate[type].stateCode = '';
            this.validate[type].country = '';

            if (type === 'address') {
              this.isZipCode1Valid = true;
            }

            if (type === 'businessAddress') {
              this.isZipCode2Valid = true;
            }
          } else {
            if (type === 'address') {
              this.customer[type].city = null;
              this.customer[type].state = null;
              this.isZipCode1Valid = false;
              this.validate.zip = 'Zip / Postal code is invalid';
            }

            if (type === 'businessAddress') {
              this.customer[type].city = null;
              this.customer[type].state = null;
              this.isZipCode2Valid = false;
              this.validate.zip2 = 'Zip / Postal code is invalid';
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isZipCodeLoading[type] = false;
      });
  }

  cityChange(type) {
    this.customer[type].zip = null;
  }

  stateChange(type: string, event: any) {
    this.customer[type].state = event.target.value;
    this.customer[type].zip = null;
    this.customer[type].city = null;
  }

  notesChange(event: any) {
    if (event.target.scrollHeight <= 148) {
      event.target.style.height = event.target.scrollHeight + 'px';
    }
  }

  /** ********** Address ********** */
  handleAddressChange(value: string, addressKey: string = 'address') {
    this.customer[addressKey].addLine1 = value;
  }

  async handleAddressSelect(event: any, addressKey: string = 'address') {
    try {
      if (event.placeId) {
        let text = [];
        this.loader[addressKey].address = true;
        const addressDetails: any = await this.httpService.googleAddressDetails({ placeId: event.placeId });
        this.customer[addressKey] = { ...this.customer[addressKey], ...addressDetails };

        if (!addressDetails.streetNumber || !addressDetails.route || !addressDetails.city || !addressDetails.state || !addressDetails.zip) {
          // text.push('Address incomplete: Please add the missing');

          if (!addressDetails.streetNumber || !addressDetails.route) text.push('Street Number or Route');
          if (!addressDetails.zip) text.push('Zip Code');
          if (!addressDetails.city) text.push('City');
          if (!addressDetails.state) text.push('State');

          // text.push(`in Address Line ${addressKey === 'address' ? '1' : '2'}`);
          this.helperService.showToaster('error', ['Address incomplete: Please add the missing', text.join(', '), 'in Address'].join(' '));
        }
      }

      this.validation(addressKey);
    } catch (err) {
      console.log(err);
    } finally {
      this.loader[addressKey].address = false;
    }
  }

  handleAddressClear(addressType: string = 'address') {
    this.addressResults[addressType] = [];
  }

  async handleAddressSearch(event: string, address: any = {}, addressType: string = 'address') {
    const query = { search: this.helperService.trimString(event), country: '' };

    if (address.country) query.country = address.country;
    this.loader[addressType].addLine1 = true;
    try {
      const data: any = await this.httpService.googleAddressSearch(query);
      if (data?.length >= 0) this.addressResults[addressType] = data;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader[addressType].addLine1 = false;
    }
  }

  /** ********** City ********** */
  handleCitySelect(event: any, addressKey: string = 'address') {
    this.customer[addressKey].city = event.city;
    this.customer[addressKey].state = event.state;
    this.customer[addressKey].stateCode = event.stateCode;
    this.customer[addressKey].country = event.country;

    this.validate[addressKey].city = '';
    this.validate[addressKey].state = '';
    this.validate[addressKey].stateCode = '';
    this.validate[addressKey].country = '';
  }

  handleCityClear(addressType: string = 'address') {
    if (addressType === 'address') {
      this.addressCityResults = [];
      this.customer.address.city = null;
    } else {
      this.bAddressCityResults = [];
      this.customer.businessAddress.city = null;
    }
  }

  async handleCitySearch(event: string, address: any = {}, addressType: string = 'address') {
    const query = { city: this.helperService.trimString(event), stateCode: '', country: '' };

    if (address.country) query.country = address.country;
    if (address.stateCode) query.stateCode = address.stateCode;

    try {
      const cities: any = await this.httpService.citySearch(query);

      if (addressType === 'address') {
        this.addressCityResults = cities;
      } else {
        this.bAddressCityResults = cities;
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  /** ********** State/Province ********** */
  handleStateSelect(event: any, addressKey: string = 'address') {
    this.customer[addressKey].state = event.state;
    this.customer[addressKey].stateCode = event.stateCode;
    this.customer[addressKey].country = event.country === 'CA' ? 'Canada' : 'USA';

    this.validate[addressKey].state = '';
    this.validate[addressKey].stateCode = '';
    this.validate[addressKey].country = '';
  }

  handleStateClear(addressType: string = 'address') {
    this.stateResults[addressType] = [];
    this.customer[addressType].state = '';
    this.customer[addressType].stateCode = '';
  }

  async handleStateSearch(event: string, address: any = {}, addressType: string = 'address') {
    const query = { search: this.helperService.trimString(event), country: '' };

    if (address.country) query.country = address.country;
    this.loader[addressType].state = true;
    try {
      let data: any;
      if (address.city && !new RegExp('n/a', 'i').test(address.city)) {
        const query = { city: address.city, country: '' };

        if (address.country) query.country = address.country;

        data = await this.httpService.stateFilterByCity(query);
      } else {
        data = await this.httpService.stateSearch(query);
      }

      if (data?.states?.length >= 0) this.stateResults[addressType] = data.states;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader[addressType].state = false;
    }
  }

  /** ********** Country ********** */
  handleCountrySelect(country: string, addressType: string = 'address') {
    if (this.customer[addressType].country && country !== this.customer[addressType].country) {
      if (addressType === 'address') {
        this.addressCityResults = [];
      } else {
        this.bAddressCityResults = [];
      }
      this.stateResults[addressType] = [];
      this.customer[addressType].zip = '';
      this.customer[addressType].city = '';
      this.customer[addressType].state = '';
      this.customer[addressType].stateCode = '';
    }

    this.customer[addressType].country = country;
    this.handleStateSearch('', this.customer[addressType], addressType);
  }

  _isUnique() {
    this.httpService.getCustomerIsUnique(`fullNameQBO=${this.customer.fullNameQBO}`).then(
      ({ isUnique, suggestions = [] }) => {
        if (isUnique) {
          this.isQboFullNameUniqe = true;
          this.validate.fullNameQBO = '';
        } else {
          this.nameSuggestions = suggestions;
          this.validate.fullNameQBO = 'Display name must be unique';
          this.isQboFullNameUniqe = false;
        }
      },
      (err) => {},
    );
  }

  validation(field: string = ''): Boolean {
    let isFormValid = true;
    let hasScrollAlready = 0;
    let isAllowScroll = true;

    if (this.isZipCodeLoading.businessAddress || this.isZipCodeLoading.address) return;

    this.validate = { address: {} };
    this.errors = {
      emails: {},
      phones: {},
      address: {
        addLine1: '',
        city: '',
        state: '',
        stateCode: '',
        zip: '',
        country: '',
      },
    };

    if (field === 'address' || field === '') {
      if (this.customerMandatoryFields?.address) {
        if (!trim(this.customer.address?.addLine1)) {
          this.validate.address.addLine1 = 'Please enter the Address.';
          isFormValid = false;
        }

        if (!trim(this.customer.address?.zip)) {
          this.validate.address.zip = 'Please enter the Zip Code.';
          isFormValid = false;
          if (this.primaryAddressElement.nativeElement) {
            this.primaryAddressElement.nativeElement.scrollIntoView();
            isAllowScroll = false;
          }
        }

        if (!trim(this.customer.address?.city)) {
          this.validate.address.city = 'Please select a City.';
          isFormValid = false;
        }

        if (!trim(this.customer.address?.state)) {
          this.validate.address.state = 'Please select a State/Province.';
          isFormValid = false;
        }

        if (!trim(this.customer.address?.country)) {
          this.validate.address.country = 'Please select a Country.';
          isFormValid = false;
        }
      }

      if (!this.isZipCode1Valid) {
        this.validate.address.zip = 'Zip / Postal code is invalid';
      }

      if (!this.isZipCode2Valid) {
        this.validate.address.zip2 = 'Zip / Postal code is invalid';
      }

      if (!this.isZipCode1Valid || !this.isZipCode2Valid) {
        isFormValid = false;
      }
      isFormValid = this.handleEmailAndPhoneValidation(isFormValid);
    }

    if (!field) {
      if (!this.helperService.trimString(this.customer.firstName)) {
        this.validate.firstName = '* First name required';
        hasScrollAlready = 0;
        isFormValid = false;
      }

      if (!this.helperService.trimString(this.customer.fullNameQBO)) {
        this.validate.fullNameQBO = '* Display name required';
        isFormValid = false;
      }

      if (!this.customer.lastName && this.customer.customerType && this.customer.customerType.value === 'customer') {
        this.validate.lastName = '* Last name required';
        hasScrollAlready = 0;
        isFormValid = false;
      }

      if (this.customer.customerType.value === 'fleet' && !this.validationService.validateCustomFleetSettings(this.fleetSettings, this.errors)) {
        isFormValid = false;
      }

      if (this.customer.firstName && !this.isQboFullNameUniqe) {
        this.validate.fullNameQBO = 'Display name must be unique';
        isFormValid = false;
      }

      if (this.customer.taxExempt && (!this.customer.taxExemptReason || (this.customer.taxExemptReason && !this.customer.taxExemptReason.qboId))) {
        this.validate.taxExemptReason = 'Reason for tax-exemption is required';
        isFormValid = false;
      }
      isFormValid = this.handleEmailAndPhoneValidation(isFormValid);
    }

    // if (!this.isZipCode1Valid) {
    //   this.validate.address.zip = 'Zip / Postal code is invalid';
    // }

    // if (!this.isZipCode2Valid) {
    //   this.validate.address.zip2 = 'Zip / Postal code is invalid';
    // }

    // const isValid = isFormValid && this.isZipCode1Valid && this.isZipCode2Valid;

    if (!isFormValid && isAllowScroll) {
      this.scrollToTop(hasScrollAlready);
    }

    return isFormValid;
  }

  cancelCreated() {
    this.cancelCreatedForOther.emit({
      openFrom: this.openFrom,
    });
  }

  toggleAddTagBtn() {
    this.isCreateTagFieldVisible = false;
  }

  handleCreateBtnClick(event) {
    this.scrollToBottom();
  }

  selectNameSuggestion(name: string) {
    this.customer.fullNameQBO = name;
    this.isQboFullNameUniqe = true;
    this.validate.fullNameQBO = '';
    this._isUnique();
  }

  async onSubmit() {
    /*
   Here we are validating if mobile not selected then add a new row for mobile field
   */
    let isFormValid = true;
    if (this.dataService.customerPhoneRequired) {
      const addPhoneRow = this.customer.phones.find(({ contactType }) => contactType?.value === 'mobile');
      if (!addPhoneRow) {
        if (this.customer.phones.length < 5) {
          this.handleAddAnother('phone');
        } else {
          this.helperService.showToaster('error', `Mobile number required`);
          isFormValid = false;
        }
      }

      const primaryPhoneValid = this.customer.phones.every(({ isPrimary }) => !isPrimary);
      if (primaryPhoneValid) {
        this.helperService.showToaster('error', `Mobile number required`);
        isFormValid = false;
      }
    }

    if (!this.validation() || !isFormValid) {
      return;
    }

    const response = await this.httpService.getCustomerIsUnique(`fullNameQBO=${this.customer.fullNameQBO}`);

    if (response) {
      if (response.isUnique) {
        this.isQboFullNameUniqe = true;
        this.validate.fullNameQBO = '';
      } else {
        this.isQboFullNameUniqe = false;
      }
    }

    this.customer.contactOnEmail = this.contactOnEmail;
    this.customer.contactOnPhone = this.contactOnPhone;

    if (this.customer.emails && this.customer.emails.length) {
      this.customer.email = this.customer.emails.filter(({ isPrimary }) => isPrimary)[0].value;
    }

    if (this.customer.phones && this.customer.phones.length) {
      const [primaryPhone] = this.customer.phones.filter(({ isPrimary }) => isPrimary);

      if (primaryPhone && primaryPhone.value) {
        this.customer.phone = primaryPhone.value;
      }

      const [landline] = this.customer.phones.filter(({ contactType, isActive }) => contactType && contactType.value === 'landline' && isActive);

      if (landline && landline.value) {
        this.customer.phone2 = landline.value;
      }
    }

    let data = { ...this.helperService.deepCopy(this.customer) };
    const { customerType, companyName, isFleetCustomer } = this.customer;

    if (customerType && customerType.value) {
      if (customerType.value === 'fleet') {
        data.companyName = this.customer.firstName;
        data.fullName = this.customer.firstName;
        if (this.isChargeAccountEnabled) {
          data.chargeAccountEnable = true;
        }
      } else {
        data.companyName = (companyName && companyName.name) || '';
      }

      data.isFleetCustomer = customerType.value === 'fleet';
    }

    if (data.isFleetCustomer) {
      data.lastName = '';
      data = { ...data, ...this.formatService.formatFleetSettings(this.fleetSettings) };
    }

    if (this.customer.emails && this.customer.emails.length) {
      data.emails = [];
      this.customer.emails.forEach((email: any) => {
        if (email.value) {
          data.emails.push({
            ...email,
            contactType: 'email',
          });
        }
      });
    }

    if (this.customer.phones && this.customer.phones.length) {
      data.phones = [];
      this.customer.phones.forEach((phone: any) => {
        if (phone.value && phone.contactType && phone.contactType.value) {
          data.phones.push({
            ...phone,
            value: this.helperService.removePhoneFormatting(phone.value),
            contactType: phone.contactType.value,
          });
        }
      });
    }

    if (this.customer.taxExempt && this.customer.taxExemptReason && this.customer.taxExemptReason.qboId) {
      data.taxExemptReasonId = this.customer.taxExemptReason.qboId;
    }

    if (!data.email) {
      delete data.email;
    }

    if (this.isProcessing) {
      return;
    }

    data.isCreatedFromEstimate = this.from === 'estimate';
    data.preferredLanguage = this.currentLang.toUpperCase();
    this.setProcessingState(true);

    // Set notification flags on contact-level emails
    if (this.customer.emails && this.customer.emails.length) {
      data.emails = [];
      this.customer.emails.forEach((email: any) => {
        if (email.value) {
          data.emails.push({
            ...email,
            contactType: 'email',
            isMarketingNotifEnabled: true,
            isOperationalNotifEnabled: true,
          });
        }
      });
    }

    // Set notification flags on contact-level phones
    if (this.customer.phones && this.customer.phones.length) {
      data.phones = [];
      this.customer.phones.forEach((phone: any) => {
        if (phone.value && phone.contactType && phone.contactType.value) {
          data.phones.push({
            ...phone,
            value: this.helperService.removePhoneFormatting(phone.value),
            contactType: phone.contactType.value,
            isMarketingNotifEnabled: phone.contactType.value === 'mobile',
            isOperationalNotifEnabled: phone.contactType.value === 'mobile',
          });
        }
      });
    }

    this.httpService.createCustomer(data).then(
      (customer) => {
        this.getEventsAfterCustomer(customer, companyName, isFleetCustomer);
      },
      (error) => {
        this.setProcessingState(false);
        this.helperService.showToaster('error', error);
      },
    );
  }

  getEventsAfterCustomer(customer, companyName, isFleetCustomer) {
    if (this.openFrom === 'add-customer') {
      this.customerCreated.emit({
        customer: {
          _id: customer._id,
          fullName: customer.fullName,
          fullNameQBO: customer.fullNameQBO,
          email: customer.email,
          phone: customer.phone,
          customer: customer,
          companyName,
          isFleetCustomer,
        },
        openFrom: this.openFrom,
      });
    } else {
      this.customerCreatedForOther.emit({
        customer: {
          _id: customer._id,
          fullName: customer.fullName,
          fullNameQBO: customer.fullNameQBO,
          email: customer.email,
          phone: customer.phone,
          contact: customer.contact,
          companyName,
          isFleetCustomer,
        },
        openFrom: this.openFrom,
      });
      if (this.from === 'quick-tire-lookup') {
        this.customerProcessingMode.emit(false);
      }
      this.setProcessingState(false);
      this.helperService.showToaster('success', messages.customerCreation);

      if (customer.followUps && customer.followUps.length) {
        this.dataService.sendData(
          this.dataService.typeFollowUp('RO', {
            event: 'customer_created',
            customer,
            followUps: customer.followUps,
            customerId: customer._id,
          }),
        );
      }
    }
  }

  handleDeleteContact(type: string, index: number) {
    this.customer[type].splice(index, 1);
    this.errors[type][index] = {};
    this.handleDisableContactPref();
  }

  onFirstLastNameChange() {
    if (this.customer.firstName && this.customer.lastName) {
      this.isUnique();
    }
  }

  onQboDisplayNameChange(event: any) {
    this.isDisplayNameChanged = true;
    this.customer.fullNameQBO = event.target.value;
  }

  handleEmailPhoneCheckboxChange(type: string, event: any) {
    this[type] = event;
  }

  scrollToTop(scrollHeight: any) {
    setTimeout(() => {
      try {
        this.addCustomerForm.nativeElement.scrollTop = scrollHeight;
      } catch (err) {}
    }, 100);
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.addCustomerForm.nativeElement.scrollTop = this.addCustomerForm.nativeElement.scrollHeight;
      } catch (err) {}
    }, 100);
  }

  onUpdateCompany({ name, _id }) {
    const tag = {
      _id,
      type: config.tags.companyName,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.companies.length; i++) {
          if (this.companies[i]._id === _id) {
            this.companies[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.companiesSuggestions.length; i++) {
          if (this.companiesSuggestions[i]._id === _id) {
            this.companiesSuggestions[i].name = name;
            break;
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleClearSearch() {
    this.companiesSuggestions = [...this.companies];
  }

  handleSaveCompany({ name }) {
    this.httpService
      .createTag({
        name,
        type: config.tags.companyName,
      })
      .then(
        (company: any) => {
          if (company) {
            this.helperService.showToaster('success', messages.companyNameCreated);
            this.companies.push(company);
            this.customer.companyName = company;
            this.companiesSuggestions = [...this.companies];
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
  }

  handleSearchCompany(query: string) {
    this.companiesSuggestions = [];
    query = this.helperService.trimString(query);

    this.companiesSuggestions = this.companies.filter(({ name }) => {
      if (name && new RegExp(`${query}`, 'gi').test(name)) {
        return true;
      } else {
        return false;
      }
    });
  }

  /*
      START*******************ALP-11411*******************START
  */

  validatePhoneRecommendation(data: any, phone: string) {
    if (!phone && data.isPrimary && !data.focus) {
      data.tooltipText = `Adding phone is recommended`;
      return `fal fa-exclamation-triangle font-13 primary-contact`;
    }
  }

  validateEmailRecommendation(data: any, email: string) {
    if (!email && data.isPrimary && !data.focus) {
      data.tooltipText = `Adding email is recommended`;
      return `fal fa-exclamation-triangle font-13 primary-contact`;
    }
  }

  validateEmailRequired(data: any, email: string) {
    if (!email && data.isPrimary && !data.focus) {
      data.tooltipText = `Email is a required field`;
      return `fal fa-exclamation-triangle font-13 primary-contact-danger`;
    }
  }

  validatePhoneRequired(data: any, phone: string) {
    if (!phone && data.isPrimary && !data.focus) {
      data.tooltipText = `Phone number is a required field`;
      return `fal fa-exclamation-triangle font-13 primary-contact-danger`;
    }
  }

  handleTooltipClass(data: any) {
    if (data) {
      const phone = this.customer.phones.find(({ isPrimary, value }) => isPrimary && value);
      const email = this.customer.emails.find(({ isPrimary, value }) => isPrimary && value);

      if (data.contactType.value === 'email') {
        if (this.dataService.customerMandatoryFields.email) {
          return this.validateEmailRequired(data, email);
        } else {
          return this.validateEmailRecommendation(data, email);
        }
      }

      if (data.contactType.value === 'mobile') {
        if (this.dataService.customerMandatoryFields.mobile) {
          return this.validatePhoneRequired(data, phone);
        } else {
          return this.validatePhoneRecommendation(data, phone);
        }
      }
    }
  }

  handleAddAsterisk({ contactType, isPrimary }) {
    if (contactType?.value === 'email') {
      return this.dataService.customerMandatoryFields.email && isPrimary ? 'Email*' : 'Email';
    } else if (contactType?.value === 'mobile') {
      return this.dataService.customerMandatoryFields.mobile && isPrimary ? 'Phone*' : 'Phone';
    } else if (contactType?.value === 'landline') return 'Phone';
  }

  handleEmailAndPhoneValidation(isFormValid = true, objIndex?: any) {
    if (this.customer.emails?.length) {
      const emails = [];
      this.customer.emails.forEach((email: any, index: number) => {
        this.errors.emails[index] = {};

        if ((objIndex?.index === index && objIndex?.type === 'emails') || !objIndex) {
          if (emails.includes(email.value)) {
            this.errors.emails[index].value = `Add a unique email`;
            isFormValid = false;
          }

          if (email.value) {
            if (email.value && !this.validationService.validateEmail(email.value)) {
              this.errors.emails[index].value = 'Email is not valid';
              isFormValid = false;
            }

            emails.push(email.value);
          }

          if (this.dataService.customerMandatoryFields.email) {
            if (!email.value && email.isPrimary) {
              this.errors.emails[index].value = '* Email required';
              isFormValid = false;
            }
          }
        }
      });
    }

    if (this.customer.phones?.length) {
      const phones = [];

      this.customer.phones.forEach((phone: any, index: number) => {
        this.errors.phones[index] = {};
        phone.value = this.helperService.removePhoneFormatting(phone.value);

        if ((objIndex?.index === index && objIndex?.type === 'phones') || !objIndex) {
          if (phones.includes(phone.value)) {
            this.errors.phones[index].value = `Add a unique number`;
            isFormValid = false;
          }

          if (phone.value) {
            if ((phone.value || '').length < 10) {
              this.errors.phones[index].value = `Phone is not valid`;
              isFormValid = false;
            }

            phones.push(phone.value);
          }

          if (this.dataService.customerMandatoryFields.mobile) {
            if (!phone.value && phone.isPrimary) {
              this.errors.phones[index].value = '* Phone required';
              isFormValid = false;
            }
          }
        }
      });
      return isFormValid;
    }
  }
  /*
      END*******************ALP-11411*******************END
  */
  handleOpenFleetCustomer() {
    const ref = this.dialogService.open(CreateMyFleetCustomerDialogComponent, {
      styleClass: 'add-dialog item-dialog new-part',
      showHeader: false,
      data: {
        fleetName: this.customer.firstName,
        fleetNumber: this.customer.fleetNumber,
        openFrom: this.openFrom,
        isHideVehicle: true,
      },
    });
    const onClose = ref.onClose.subscribe((response: any) => {
      if (response.fleetNumber) {
        console.log(response);
        this.getEventsAfterCustomer(response, response.company, true);
      }
      onClose.unsubscribe();
    });
  }
}
